import type { AxiosPromise } from "axios";
import { apiClient } from "@/api/modules/base";
import { Route } from "@/api/modules/autoQ/customers/route";
import type {
    CustomerCreateRequest,
    CustomerCreateResponse, CustomerExistsResponse,
    CustomerSearchRequest,
    CustomersListItem
} from "@/api/modules/autoQ/customers/types";
import type { CustomerSearchResponse } from "@/api/modules/autoQ/customers/searchResultTypes";

export const list = (): AxiosPromise<CustomersListItem[]> =>
    apiClient.get(Route.Customers);

export const create = (payload: CustomerCreateRequest): AxiosPromise<CustomerCreateResponse> =>
    apiClient.post(Route.Customers, payload);

export const exists = (customerNumber: string): AxiosPromise<CustomerExistsResponse> =>
    apiClient.get(Route.CustomersExists, { params: { customerNumber } });

export const search = (payload: CustomerSearchRequest): AxiosPromise<CustomerSearchResponse> =>
    apiClient.post(Route.CustomersSearch, payload);
